import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { DeleteWarningIcon } from "../../../components/ui/icons";
import { useDeleteDeviceExecutables } from "./useDeleteDeviceExecutables";
function DeleteDeviceExecutablesModal(props) {
  const { name, version, isFirmware } = props;

  const { handleDeleteButtonClick, showModel, handleClose, handleShow } = useDeleteDeviceExecutables(
    name,
    version,
    isFirmware
  );
  return (
    <>
      <a onClick={handleShow}>Delete</a>

      <Modal
        show={showModel}
        onHide={handleClose}
        className="modal-container"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="delete-heading">
              <DeleteWarningIcon></DeleteWarningIcon>
              <h1>Delete</h1>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Are you sure you want to delete the{" "}
            <strong>
              {name}_v{version}
            </strong>
            ?
          </p>
        </Modal.Body>

        <Modal.Footer>
          <Button className="btn-cancel" onClick={handleClose}>
            Cancel
          </Button>
          <Button className="btn-delete" onClick={handleDeleteButtonClick}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default DeleteDeviceExecutablesModal;
